function corners(list) {
  if (list.length === 0) {
    return undefined;
  }
  const minMax = list.slice(1).reduce(
    (acc, pt) => ({
      min: {
        lat: Math.min(acc.min.lat, pt.lat),
        lng: Math.min(acc.min.lng, pt.lng),
      },
      max: {
        lat: Math.max(acc.max.lat, pt.lat),
        lng: Math.max(acc.max.lng, pt.lng),
      },
    }),
    { min: list[0], max: list[0] },
  );
  return Object.values(minMax);
}

export default corners;
